module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/462.48f386d2.png";